import { createListenerMiddleware } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { handleQueryError } from 'store/utils';

import { insightsReportApi } from './insightsReportApi';

export const insightsReportApiLister = createListenerMiddleware<RootState>();

insightsReportApiLister.startListening({
  matcher: insightsReportApi.endpoints.validateReportPin.matchRejected,
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, 'Unable to validate PIN');
  },
});
